module.exports = __webpack_public_path__ + "img/背景色2.5da5f363.png";